<template>
    <div class="container q-py-sm">
        <div class="row items-center no-wrap justify-center" style="background-color: #f22;color:white"
             v-if="user && (user.dcb_mnc == '1' ||user.dcb_mnc == '01') && $route.name != 'cancel-subscription'  ">
                <router-link style="color: #ffffff" to="/cancel-subscription">Cancelar</router-link>
        </div>
        <div class="row items-center no-wrap justify-between">
            <a href="/" @click="clearTimeout()"><img src="../../img/identity/p4f.svg" :alt="appName" class="logo" ></a>

            <div class="col-auto row items-center">
                <ul class="gt-sm">
                  <li v-for="menu in menus"><router-link :to="menu.slug" @click="clearTimeout()">{{ $T(menu.name) }}</router-link></li>
                </ul>
                <!--<ul class="gt-sm">
                    <li v-for="menu in menus"><a :href="menu.slug" @click="clearTimeout()">{{ $T(menu.name) }}</a></li>
                </ul>-->
                <q-btn no-caps dense flat rounded color="faded" v-ripple
                       icon="person" class="account on-right gt-sm"
                       :label="$T('my account')">
                    <q-popover class="account">
                        <q-list separator class="q-pt-none">
                            <template v-if="user">
                                <q-item v-close-overlay class="justify-center" link to="/profile">
                                    {{ $T('account settings') }}
                                </q-item>
                                <q-item  v-close-overlay class="justify-center" link to="/favourites">
                                    {{ $T('favourites') }}
                                </q-item>
                            </template>
                            <template>
                                <q-item  v-close-overlay class="justify-center" link  :to="{name: 'contact'}">
                                    {{ $T('contact us') }}
                                </q-item>
                                <q-item  v-close-overlay class="justify-center" link :to="{name: 'tec'}">
                                    {{ $T('terms ans conditions') }}
                                </q-item>
                                <!--<q-item v-close-overlay class="justify-center" link to="/subscriptions">-->
                                    <!--{{ $T('subscription') }}-->
                                <!--</q-item>-->

                            </template>


                            <q-item v-if="user">
                                <div class="col q-pa-sm">
                                    <p class="q-mt-sm q-mb-md">{{$T("close your session")}}</p>
                                    <q-btn no-caps color="primary" link v-ripple @click.native="logout" v-close-overlay class="full-width super-hover"
                                           :label="$T('log out')"></q-btn>
                                </div>
                            </q-item>

                            <!-- Guest -->
                            <q-item v-else>
                                <div class="col q-pa-sm">
                                    <p class="q-mt-sm q-mb-md">{{$T("start your session")}}</p>
                                    <q-btn  no-caps color="primary" v-close-overlay class="full-width super-hover"
                                           :label="$T('log in')" @click.prevent="$login()"></q-btn>
                                </div>
                            </q-item>

                        </q-list>
                    </q-popover>
                </q-btn>

                <q-btn round size="sm" color="primary" icon="menu" class="lt-md"
                       @click="$emit('rightDrawerToogle')"></q-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'
    import {
        QBtn,
        QPopover,
        QList,
        QItem
    } from 'quasar-framework'
    import Spinner from "./spinner/Spinner"

    export default {
        data: () => ({
            appName: window.config.appName
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),

            menus() {
                return window.config.menus
            }
        },

        components: {
            Spinner,
            QBtn,
            QPopover,
            QList,
            QItem
        },

        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push("/")
            },
            setLocale(locale) {
              this.$q.i18n.rtl=false;
              if (this.$i18n.locale !== locale) {
                loadMessages(locale)

                this.$store.dispatch('lang/setLocale', {locale})
                this.$q.i18n.rtl=false;
                window.location.href = this.$route.path
              }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header.vue